/* eslint-disable default-param-last */
/**
 * Extracts content from array of vehicleSpecList.
 * @param {Array} trims Array of objects that have a type and content key.
 */
export function getMultipageVehicleSpecs(trims) {
  if (!trims || !trims.length) return [];
  return trims.map(trim => trim.items)
    .reduce((result = [], item) => result.concat(item))
    .map(item => ({ url: item.path, title: item.name }));
}
